import { Fragment, useState, useContext } from "react";
import DataContext from "../../context/data-context";
import PaymentDetail from "./PaymentCard";
import SearchBar from "../UI/SearchBar";
import Heading from "../UI/Heading";
import { useNavigate } from "react-router-dom";
import { MdAdd, MdRefresh } from "react-icons/md";

export default function Payments() {
  const { partner, fetchData } = useContext(DataContext);
  const navigate = useNavigate();
  return (
    <div className="container grid gap-4 overflow-hidden">
      <Heading
        title="Payments"
        description={`This lists shows all the payments you have 
        requested or received from us. To send a new request, click 
        the '+' icon.`}
      >
        <MdAdd onClick={() => navigate("/payments/add")} className="icon" />
        <MdRefresh onClick={fetchData} className="icon" />
      </Heading>
      <SearchBar />

      <div className="list">
        {partner.payments.map((payment) => (
          <PaymentDetail payment={payment} />
        ))}
      </div>

      <p className="ml-auto text-sm text-stone-400">
        Showing {partner.payments.length} - Total $
        {Number(
          partner.payments.reduce((acc, p) => acc + Number(p.amount), 0)
        ).toFixed(2)}
      </p>
    </div>
  );
}
